var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-head"},[_c('div',{staticClass:"group-name",class:{ en: _vm.$i18n.locale === 'en' },style:({
        'max-width': _vm.config && _vm.config.width || undefined
    }),domProps:{"innerHTML":_vm._s(_vm.group.name)}},[_vm._v(_vm._s(_vm.group.name))]),(_vm.$i18n.locale !== 'en')?_c('div',{staticClass:"group-name-en",style:({
        'max-width': _vm.config && _vm.config.enWidth || undefined
    }),domProps:{"innerHTML":_vm._s(_vm.group.nameEN)}},[_vm._v(_vm._s(_vm.group.nameEN))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea6a528","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupHead.vue
// module id = 3DlY
// module chunks = 6